import { render, staticRenderFns } from "./VerClienteProveedorModal.vue?vue&type=template&id=8531d496&"
import script from "./VerClienteProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./VerClienteProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8531d496', component.options)
    } else {
      api.reload('8531d496', component.options)
    }
    module.hot.accept("./VerClienteProveedorModal.vue?vue&type=template&id=8531d496&", function () {
      api.rerender('8531d496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/VerClienteProveedorModal.vue"
export default component.exports